module.exports = __webpack_public_path__ + "img/save.109ce453.svg";